import { render, staticRenderFns } from "./MenuOnline.vue?vue&type=template&id=4d134d4a&scoped=true"
import script from "./MenuOnline.vue?vue&type=script&lang=js"
export * from "./MenuOnline.vue?vue&type=script&lang=js"
import style0 from "./MenuOnline.vue?vue&type=style&index=0&id=4d134d4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d134d4a",
  null
  
)

export default component.exports